module.exports = __webpack_public_path__ + "img/post-blog-habilidades-tecnico-design-interiores@2x.4f2c7aca.png";